<template>
  <v-dialog
    v-model="visible"
    class="person-modal"
    scrollable
    max-width="750"
  >
    <v-card
      v-if="action === 'delete'"
      class="pa-6"
    >
      <v-card-title primary-title>
        <div class="headline darkestblue--text">
          Are you sure?
        </div>
        <v-card-actions>
          <v-btn
            :ripple="false"
            icon
            @click.stop="close(action)"
          >
            <v-icon color="brightblue">
              close
            </v-icon>
          </v-btn>
        </v-card-actions>
      </v-card-title>

      <v-card-text>
        <div class="coolgray--text">
          <v-row>
            <v-col class="subtitle-2">
              ID
            </v-col>
            <v-col class="body-1">
              {{ entry.personId }}
            </v-col>
          </v-row>

          <v-row>
            <v-col class="subtitle-2">
              First Name
            </v-col>
            <v-col class="body-1">
              {{ entry.personNameFirst }}
            </v-col>
          </v-row>

          <v-row>
            <v-col class="subtitle-2">
              Last Name
            </v-col>
            <v-col class="body-1">
              {{ entry.personNameLast }}
            </v-col>
          </v-row>
        </div>
      </v-card-text>

      <v-card-actions class="justify-end">
        <v-btn
          text
          color="coolgray"
          @click.stop="cancelAction"
        >
          Cancel
        </v-btn>

        <v-btn
          color="primary"
          @click.stop="submitAction('delete')"
        >
          Delete
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-card
      v-if="['create', 'update'].includes(action)"
      class="pa-4"
    >
      <v-card-title>
        <span>
          {{ action === 'create' ? 'Add' : 'Edit' }} Person
        </span>

        <v-card-actions>
          <v-btn
            :ripple="false"
            icon
            @click.stop="close(action)"
          >
            <v-icon color="brightblue">
              close
            </v-icon>
          </v-btn>
        </v-card-actions>
      </v-card-title>

      <v-card-text>
        <v-form
          ref="personForm"
          v-model="isValidPersonForm"
        >
          <v-container>
            <v-row>
              <v-col>
                <v-row>
                  <h4 class="pl-3">
                    Contact
                  </h4>
                </v-row>

                <v-row>
                  <v-col>
                    <v-text-field
                      v-model="entryFirstName"
                      label="First Name"
                      name="personNameFirst"
                      required
                      :rules="rulesRequired"
                      type="textual"
                    />

                    <v-text-field
                      v-model="entryLastName"
                      label="Last Name"
                      name="personNameLast"
                      required
                      :rules="rulesRequired"
                      type="textual"
                    />

                    <v-text-field
                      v-model="entryEmail"
                      label="Email"
                      name="email"
                      required
                      :rules="rulesEmail"
                      type="textual"
                    />
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <v-row>
                      <h4 class="pl-3">
                        iAdOps Access
                      </h4>
                    </v-row>

                    <v-row>
                      <v-col>
                        <div class="checkbox-field">
                          <Checkbox
                            :input-value="entry.access.active"
                            @change="entry.access.active = $event"
                          />
                          <div class="checkbox-field__content">
                            <div class="checkbox-field__label">
                              iAdOps
                            </div>
                          </div>
                        </div>

                        <v-menu
                          ref="entryDate"
                          v-model="entryDateMenu"
                          :return-value="entry.access.expires"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="entryDateText"
                              label="Expires"
                              readonly
                              v-on="on"
                            />
                          </template>

                          <v-date-picker
                            v-model="entry.access.expires"
                            no-title
                            scrollable
                            @input="$refs.entryDate.save(entry.access.expires)"
                          />
                        </v-menu>

                        <v-select
                          v-model="entry.access.level"
                          autocomplete="off"
                          clearable
                          :items="levels"
                          label="Level"
                          name="level"
                        />

                        <v-select
                          v-model="entryAccessRole"
                          autocomplete="off"
                          clearable
                          :items="roles"
                          label="Role"
                          name="role"
                        />

                        <v-select
                          v-model="entry.access.type"
                          clearable
                          :items="accountTypes"
                          label="Account Type"
                          name="accountType"
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <!-- Tenants -->

                <v-row class="mt-4">
                  <v-col>
                    <v-row>
                      <v-col>
                        <h4>
                          Tenant
                        </h4>

                        <!-- Instructions -->
                        <v-row>
                          <v-col class="body-2 font-weight-medium midgray--text">
                            <span>
                              Define the user's tenant.
                            </span>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col>
                        <v-text-field
                          v-model="entry.domainName"
                          autocomplete="off"
                          label="Domain Name"
                          name="domainName"
                          clearable
                        />

                        <v-text-field
                          v-model="entry.enterpriseId"
                          autocomplete="off"
                          label="Enterprise ID"
                          name="enterpriseId"
                          clearable
                        />

                        <v-text-field
                          v-model="entry.tenantId"
                          autocomplete="off"
                          label="Tenant"
                          name="tenantId"
                          clearable
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <v-row>
                      <h4 class="pl-3">
                        Networks
                      </h4>
                    </v-row>

                    <v-row>
                      <v-col>
                        <v-autocomplete
                          v-model="currentNetworks"
                          autocomplete="off"
                          :items="organizations"
                          label="Organizations"
                          name="organizations"
                          clearable
                          multiple
                          return-object
                        />

                        <v-autocomplete
                          v-if="currentNetworks.length"
                          v-model="currentTeams"
                          autocomplete="off"
                          :items="optionsTeams"
                          label="Teams"
                          name="teams"
                          item-text="text"
                          item-value="uniqueId"
                          clearable
                          multiple
                          return-object
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row
                  v-if="entry.access.role === 'internal'"
                >
                  <v-col>
                    <v-row>
                      <h4 class="pl-3">
                        Associations
                      </h4>
                    </v-row>

                    <v-row>
                      <v-col>
                        <v-autocomplete
                          v-model="entry.managerPersonId"
                          autocomplete="off"
                          :items="internals"
                          item-value="personId"
                          label="Manager"
                          name="managerPersonId"
                          clearable
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <v-row>
                      <h4 class="pl-3">
                        Custom Roles
                      </h4>
                    </v-row>

                    <v-row>
                      <v-col>
                        <div class="checkbox-field">
                          <Checkbox
                            :input-value="entry.access.permissions.dev"
                            @change="entry.access.permissions.dev = $event"
                          />
                          <div class="checkbox-field__content">
                            <div class="checkbox-field__label">
                              Developer
                            </div>
                            <div class="checkbox-field__hint">
                              Allow the user to access developer features, including the Develop Module.
                            </div>
                          </div>
                        </div>

                        <div class="checkbox-field">
                          <Checkbox
                            :input-value="entry.access.permissions.admin"
                            @change="entry.access.permissions.admin = $event"
                          />
                          <div class="checkbox-field__content">
                            <div class="checkbox-field__label">
                              Administrator
                            </div>
                            <div class="checkbox-field__hint">
                              Allow the user to administrate the iAdOps system on behalf of their enterprise.
                            </div>
                          </div>
                        </div>

                        <div class="checkbox-field">
                          <Checkbox
                            :input-value="entry.access.permissions.enterprise"
                            :disabled="!entry.access.permissions.admin"
                            @change="entry.access.permissions.enterprise = $event"
                          />
                          <div class="checkbox-field__content">
                            <div class="checkbox-field__label">
                              Enterprise
                            </div>
                            <div class="checkbox-field__hint">
                              Allow the admin to access enterprise features.
                            </div>
                          </div>
                        </div>

                        <div class="checkbox-field">
                          <Checkbox
                            :input-value="entry.access.permissions.logs"
                            :disabled="!entry.access.permissions.admin"
                            @change="entry.access.permissions.logs = $event"
                          />
                          <div class="checkbox-field__content">
                            <div class="checkbox-field__label">
                              Logs
                            </div>
                            <div class="checkbox-field__hint">
                              Allow the admin to access logs related to their account and enterprise.
                            </div>
                          </div>
                        </div>

                        <div class="checkbox-field">
                          <Checkbox
                            :input-value="entry.access.permissions.security"
                            :disabled="!entry.access.permissions.admin"
                            @change="entry.access.permissions.security = $event"
                          />
                          <div class="checkbox-field__content">
                            <div class="checkbox-field__label">
                              Security
                            </div>
                            <div class="checkbox-field__hint">
                              Allow the admin to manage security features for their enterprise.
                            </div>
                          </div>
                        </div>

                        <div class="checkbox-field">
                          <Checkbox
                            :input-value="entry.access.permissions.users"
                            :disabled="!entry.access.permissions.admin"
                            @change="entry.access.permissions.users = $event"
                          />
                          <div class="checkbox-field__content">
                            <div class="checkbox-field__label">
                              Users
                            </div>
                            <div class="checkbox-field__hint">
                              Allow the admin to manage users for their enterprise.
                            </div>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <v-row>
                      <h4 class="pl-3">
                        Permissions & Settings
                      </h4>
                    </v-row>

                    <v-row>
                      <v-col>
                        <h5>
                          Features
                        </h5>

                        <div class="checkbox-field">
                          <Checkbox
                            :input-value="entry.access.permissions.alias"
                            @change="entry.access.permissions.alias = $event"
                          />
                          <div class="checkbox-field__content">
                            <div class="checkbox-field__label">
                              Alias Mode
                            </div>
                          </div>
                        </div>

                        <div class="checkbox-field">
                          <Checkbox
                            :input-value="entry.access.permissions.bulk"
                            @change="entry.access.permissions.bulk = $event"
                          />
                          <div class="checkbox-field__content">
                            <div class="checkbox-field__label">
                              Bulk Actions
                            </div>
                          </div>
                        </div>

                        <div class="checkbox-field">
                          <Checkbox
                            :input-value="entry.access.permissions.burtForecast"
                            @change="entry.access.permissions.burtForecast = $event"
                          />
                          <div class="checkbox-field__content">
                            <div class="checkbox-field__label">
                              BurtForecast Button
                            </div>
                          </div>
                        </div>

                        <div class="checkbox-field">
                          <Checkbox
                            :input-value="entry.access.permissions.burtHub"
                            @change="entry.access.permissions.burtHub = $event"
                          />
                          <div class="checkbox-field__content">
                            <div class="checkbox-field__label">
                              BurtHub Button
                            </div>
                          </div>
                        </div>

                        <div class="checkbox-field">
                          <Checkbox
                            :input-value="entry.access.permissions.demo"
                            @change="entry.access.permissions.demo = $event"
                          />
                          <div class="checkbox-field__content">
                            <div class="checkbox-field__label">
                              Demo
                            </div>
                          </div>
                        </div>
                      </v-col>

                      <v-col>
                        <h5>
                          Reports
                        </h5>

                        <div class="checkbox-field">
                          <Checkbox
                            :input-value="entry.access.permissions.pacing"
                            @change="entry.access.permissions.pacing = $event"
                          />
                          <div class="checkbox-field__content">
                            <div class="checkbox-field__label">
                              Pacing
                            </div>
                          </div>
                        </div>

                        <div class="checkbox-field">
                          <Checkbox
                            :input-value="entry.access.permissions.discrepancy"
                            @change="entry.access.permissions.discrepancy = $event"
                          />
                          <div class="checkbox-field__content">
                            <div class="checkbox-field__label">
                              Discrepancy
                            </div>
                          </div>
                        </div>

                        <div class="checkbox-field">
                          <Checkbox
                            :input-value="entry.access.permissions.programmatic"
                            @change="entry.access.permissions.programmatic = $event"
                          />
                          <div class="checkbox-field__content">
                            <div class="checkbox-field__label">
                              Programmatic
                            </div>
                          </div>
                        </div>

                        <div class="checkbox-field">
                          <Checkbox
                            :input-value="entry.hasCustomReportsActive"
                            @change="entry.hasCustomReportsActive = $event"
                          />
                          <div class="checkbox-field__content">
                            <div class="checkbox-field__label">
                              Custom Reports
                            </div>
                          </div>
                        </div>
                      </v-col>
                    </v-row>

                    <v-row
                      v-if="entry.access.permissions.alias"
                    >
                      <v-col>
                        <v-row>
                          <h4 class="pl-3">
                            Alias
                          </h4>
                        </v-row>

                        <v-row>
                          <v-col>
                            <v-combobox
                              :items="aliasEmailOptions"
                              label="Alias Email"
                              :value="entryAliasEmail"
                              flat
                              dense
                              hide-details
                              solo
                            />
                          </v-col>
                        </v-row>

                        <v-row class="mt-0 mx-0 mb-2">
                          <v-col>
                            <v-switch
                              v-model="entry.settings.alias.active"
                              :label="entry.settings.alias.active ? 'Alias Mode On' : 'Alias Mode Off'"
                              active-class="primary--text"
                              class="mt-2"
                              hide-details
                              inset
                              name="settings.alias.active"
                            />
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>

                    <v-row
                      v-if="entry.hasCustomReportsActive"
                    >
                      <v-col>
                        <v-row>
                          <h4 class="pl-3">
                            Custom Reports
                          </h4>
                        </v-row>

                        <v-row
                          class="pl-8"
                        >
                          <v-col>
                            <v-autocomplete
                              v-model="entry.access.permissions.customReports"
                              autocomplete="off"
                              clearable
                              dense
                              :items="customReportOptions"
                              label="Custom Reports"
                              name="customReports"
                              :required="entry.hasCustomReportsActive"
                            />
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>

                    <v-row>
                      <h4 class="pl-3">
                        Filters
                      </h4>
                    </v-row>

                    <v-row>
                      <v-col class="pt-0 font-weight-medium">
                        <span class="midgray--text font-weight-bold">Interface in development. </span>
                        <span class="midgray--text">In the interim, </span><a
                          class="midgray--text"
                          href="mailto:tech@adops.com"
                        >contact the iAdOps team</a><span class="midgray--text"> to set up filters.</span>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col>
                        <v-row>
                          <v-col>
                            <v-btn
                              small
                              text
                              @click="openSettingFormCreate"
                            >
                              <span>
                                Add Filter
                              </span>
                            </v-btn>
                          </v-col>
                        </v-row>

                        <!-- Success: Deleted Filter Setting -->
                        <v-row>
                          <v-col
                            v-if="messageFilterSettingForm"
                            class="mb-4 mx-3 pa-3 rounded-lg icewhite body-2 font-weight-medium"
                          >
                            {{ messageFilterSettingForm }}
                          </v-col>
                        </v-row>

                        <!-- Delete Filter Setting Confirmation -->
                        <v-row>
                          <v-col
                            v-if="isDeletingFilterSetting"
                            class="mb-4 mx-3 pa-3 rounded-lg icewhite body-2 font-weight-medium"
                          >
                            <v-row>
                              <v-col>
                                <span>Are you sure you want to delete the filter
                                  "{{ filterSettings[indexOfSelectedFilterSetting].name }}"
                                  at index {{ indexOfSelectedFilterSetting }}?</span>
                              </v-col>
                            </v-row>

                            <v-row>
                              <v-col>
                                <v-btn
                                  small
                                  text
                                  @click="cancelFormToDeleteFilterSetting"
                                >
                                  <span>Cancel</span>
                                </v-btn>

                                <v-btn
                                  small
                                  text
                                  color="toasted"
                                  @click="deleteFilterSetting"
                                >
                                  <span>Delete</span>
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>

                        <!-- Render Filters -->
                        <v-row v-if="haveFilterSettings">
                          <v-col>
                            <v-row
                              v-for="(filterSetting, filterSettingIndex) in filterSettings"
                              :key="filterSettingIndex"
                            >
                              <v-col class="mb-4 mx-3 pa-4 rounded-lg icewhite">
                                <v-row class="body-2 font-weight-medium">
                                  <v-col v-if="isUpdatingFilterSettingName">
                                    <v-row>
                                      <v-col class="pb-0">
                                        <v-text-field
                                          v-model="filterSetting.name"
                                          dense
                                          label="Filter Name"
                                          name="filterName"
                                          outlined
                                          :rules="rulesRequired"
                                        />
                                      </v-col>
                                    </v-row>

                                    <v-row class="mt-0">
                                      <v-col class="pt-0">
                                        <v-btn
                                          small
                                          text
                                          @click="cancelFormToUpdateFilterName"
                                        >
                                          <span>Cancel</span>
                                        </v-btn>

                                        <v-btn
                                          small
                                          text
                                          color="primary"
                                          @click="updateFilterName"
                                        >
                                          <span>Set</span>
                                        </v-btn>
                                      </v-col>
                                    </v-row>
                                  </v-col>

                                  <v-col v-else>
                                    <v-row class="justify-space-between">
                                      <v-col
                                        class="font-weight-medium"
                                      >
                                        <div class="subtitle-2 font-weight-bold darkblue--text">
                                          <span>Name</span>

                                          <v-btn
                                            color="primary"
                                            small
                                            icon
                                            @click="openFormToUpdateFilterName(filterSettingIndex)"
                                          >
                                            <font-awesome-icon
                                              :icon="['fas', 'pencil-alt']"
                                              size="sm"
                                            />
                                          </v-btn>
                                        </div>

                                        <div class="font-weight-medium">
                                          {{ filterSetting.name }}
                                        </div>
                                      </v-col>

                                      <v-col
                                        class="col-auto font-weight-medium"
                                      >
                                        <v-btn
                                          color="toasted"
                                          icon
                                          :disabled="isDeletingFilterSetting"
                                          @click="promptToDeleteFilterSetting(filterSettingIndex)"
                                        >
                                          <font-awesome-icon
                                            :icon="['fas', 'trash-alt']"
                                          />
                                        </v-btn>
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                </v-row>

                                <v-row>
                                  <v-col>
                                    <v-row>
                                      <v-col class="col-auto py-0">
                                        <div class="subtitle-2 font-weight-bold darkblue--text">
                                          <span>Networks</span>

                                          <v-btn
                                            small
                                            icon
                                            color="primary"
                                            @click="openFormToUpdateFilterNetworks(filterSettingIndex)"
                                          >
                                            <font-awesome-icon
                                              :icon="['fas', 'pencil-alt']"
                                              size="sm"
                                            />
                                          </v-btn>
                                        </div>
                                      </v-col>
                                    </v-row>

                                    <v-row v-if="isUpdatingFilterSettingNetworks">
                                      <v-col>
                                        <v-select
                                          v-model="filterSetting.network"
                                          :items="optionsTeams"
                                          label="Select Network Teams"
                                          multiple
                                          chips
                                          clearable
                                          hide-selected
                                          item-text="text"
                                          item-value="uniqueId"
                                        />
                                      </v-col>

                                      <v-col class="col-auto">
                                        <v-btn
                                          small
                                          text
                                          @click="cancelFormToUpdateFilterNetworks"
                                        >
                                          <span>Cancel</span>
                                        </v-btn>

                                        <v-btn
                                          small
                                          text
                                          color="primary"
                                          @click="updateFilterNetworks"
                                        >
                                          <span>Set</span>
                                        </v-btn>
                                      </v-col>
                                    </v-row>

                                    <v-row v-else>
                                      <v-col>
                                        <v-row
                                          v-for="(network, networkIndex) in filterSetting.network"
                                          :key="networkIndex"
                                          class="py-0"
                                        >
                                          <v-col>
                                            <v-row>
                                              <v-col class="col-4 pt-0">
                                                <span class="font-weight-medium">Prefilter?</span>
                                              </v-col>

                                              <v-col class="col-auto pt-0">
                                                <span class="font-weight-medium">{{ network.defaults ? 'Yes' : 'No' }}</span>
                                              </v-col>
                                            </v-row>

                                            <v-row class="mt-0">
                                              <v-col class="col-4 pt-0">
                                                <span class="font-weight-medium">Billing Code</span>
                                              </v-col>

                                              <v-col class="col-auto pt-0">
                                                <span class="font-weight-medium">{{ network.billingCode }}</span>
                                              </v-col>
                                            </v-row>

                                            <v-row class="mt-0">
                                              <v-col class="col-4 pt-0">
                                                <span class="font-weight-medium">Org ID</span>
                                                <span class="ml-1 font-weight-medium toasted-text">(deprecated)</span>
                                              </v-col>

                                              <v-col class="col-auto pt-0">
                                                <span class="font-weight-medium">{{ network.organizationId }}</span>
                                              </v-col>
                                            </v-row>

                                            <v-row class="mt-0">
                                              <v-col class="col-4 pt-0">
                                                <span class="font-weight-medium">Team Code</span>
                                              </v-col>

                                              <v-col class="col-auto pt-0">
                                                <span class="font-weight-medium">{{ network.teamCode }}</span>
                                              </v-col>
                                            </v-row>

                                            <v-row class="mt-0">
                                              <v-col class="col-4 pt-0">
                                                <span class="font-weight-medium">Team ID</span>
                                              </v-col>

                                              <v-col class="col-auto pt-0">
                                                <span class="font-weight-medium">{{ network.teamId }}</span>
                                              </v-col>
                                            </v-row>
                                          </v-col>
                                        </v-row>
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                </v-row>

                                <v-row>
                                  <v-col>
                                    <v-row>
                                      <v-col class="col-auto py-0">
                                        <div>
                                          <span class="subtitle-2 font-weight-bold darkblue--text">Reports</span>

                                          <v-btn
                                            small
                                            icon
                                            color="primary"
                                            @click="openFormToUpdateFilterReports(filterSettingIndex)"
                                          >
                                            <font-awesome-icon
                                              :icon="['fas', 'pencil-alt']"
                                              size="sm"
                                            />
                                          </v-btn>
                                        </div>
                                      </v-col>
                                    </v-row>

                                    <v-row v-if="isUpdatingFilterSettingReports">
                                      <v-col>
                                        <v-select
                                          v-model="filterSetting.reports"
                                          :items="settingReportOptions"
                                          label="Select Reports"
                                          multiple
                                          chips
                                          clearable
                                          hide-selected
                                          item-text="text"
                                          item-value="value"
                                        />
                                      </v-col>

                                      <v-col class="col-auto">
                                        <v-btn
                                          small
                                          text
                                          @click="cancelFormToUpdateFilterReports"
                                        >
                                          <span>Cancel</span>
                                        </v-btn>

                                        <v-btn
                                          small
                                          text
                                          color="primary"
                                          @click="updateFilterReports"
                                        >
                                          <span>Set</span>
                                        </v-btn>
                                      </v-col>
                                    </v-row>

                                    <v-row v-else>
                                      <v-col class="py-0">
                                        <span class="font-weight-medium">{{ filterSetting.reports && filterSetting.reports.length ? filterSetting.reports.join(', ') : 'Report Associations Not Found' }}</span>
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                </v-row>

                                <v-row>
                                  <v-col>
                                    <v-row>
                                      <v-col class="col-auto">
                                        <span class="subtitle-2 font-weight-bold darkblue--text">Parameters</span>
                                      </v-col>

                                      <!-- Edit Parameters -->
                                      <v-col class="col-auto body-2 font-weight-medium">
                                        <v-btn
                                          small
                                          text
                                          @click="openFormToUpdateFilterParameters(filterSettingIndex)"
                                        >
                                          <font-awesome-icon
                                            :icon="['fas', 'pencil-alt']"
                                            size="sm"
                                          />
                                        </v-btn>
                                      </v-col>
                                    </v-row>

                                    <v-row
                                      v-for="(params, paramName) in filterSetting.parameters"
                                      :key="paramName"
                                    >
                                      <v-col class="col-4 pt-0">
                                        <div class="mr-1 font-weight-bold midgray--text">
                                          <span>Property</span>
                                        </div>

                                        <div><span class="font-weight-medium">{{ paramName }}</span></div>
                                      </v-col>

                                      <v-col class="mb-6">
                                        <v-row>
                                          <v-col class="col-4 py-0 font-weight-bold midgray--text">
                                            <span>Operator</span>
                                          </v-col>

                                          <v-col class="col-auto py-0 font-weight-bold midgray--text">
                                            <span>Value</span>
                                          </v-col>
                                        </v-row>

                                        <v-row
                                          v-for="(param, paramIndex) in params"
                                          :key="paramIndex"
                                        >
                                          <v-col class="col-4 py-0 font-weight-medium">
                                            {{ param.operator }}
                                          </v-col>

                                          <v-col class="col-auto py-0 font-weight-medium">
                                            {{ param.value }}
                                          </v-col>
                                        </v-row>
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>

                        <v-row v-else>
                          <v-col>
                            <v-row>
                              <v-col class="mb-4 mx-3 pa-3 rounded-lg icewhite body-2 font-weight-medium">
                                No Filters Found
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <!-- Form Message -->
              </v-col>

              <!-- Form Controls -->
              <v-col>
                <v-card-actions class="justify-end">
                  <v-btn
                    text
                    color="coolgray"
                    @click.stop="cancelAction"
                  >
                    Cancel
                  </v-btn>

                  <!-- Button Group: "Submit" and "Submit and Draft Copy" -->
                  <v-btn
                    dense
                    class="rounded-r-0 elevation-0"
                    color="primary"
                    @click.stop="submitAction('submit')"
                  >
                    <span class="px-2">Submit</span>
                  </v-btn>

                  <v-menu
                    v-model="showSubmitMenu"
                    transition="scale-transition"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        dense
                        class="rounded-l-0 elevation-0"
                        color="primary"
                        v-on="on"
                      >
                        <font-awesome-icon
                          :icon="['fas', 'chevron-down']"
                          size="sm"
                        />
                      </v-btn>
                    </template>

                    <v-list>
                      <v-list-item
                        v-for="(item, index) in submitMenuItems"
                        :key="index"
                        @click.stop="submitAction(item.actionName)"
                      >
                        {{ item.text }}
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-card-actions>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import _ from 'underscore'
import { createNamespacedHelpers } from 'vuex'

import dates from 'src/utils/dates'
import operators from 'src/utils/operators'
import Checkbox from '@/tools/components/Checkbox'

const { mapGetters, mapState } = createNamespacedHelpers('internal')
const { mapGetters: mapToolsGetters } = createNamespacedHelpers('tools')

export default {
  name: 'PersonModal',
  components: {
    Checkbox,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    aliasEmailOptions: [],

    loading: false,
    isValidPersonForm: true,
    selectedNetworks: [],
    selectedTeams: [],
    entryDateMenu: false,
    entrySettingParameter: { key: 'advertiserName', operator: 'eq', value: undefined },

    isEntrySettingPrefilter: false,
    isValidSettingForm: true,

    selectedFilterSetting: {},

    settingReportOptions: [
      { text: 'Discrepancy', value: 'discrepancy' },
      { text: 'Pacing', value: 'pacing' },
    ],

    showFilterSettingForm: false,
    messageFilterSettingForm: '',

    showSubmitMenu: false,

    submitMenuItems: [
      // { text: 'Submit', actionName: 'submit' },
      { text: 'Submit and Draft Copy', actionName: 'submit-and-copy' },
    ],

    isDeletingFilterSetting: false,
    isUpdatingFilterSettingName: false,
    isUpdatingFilterSettingNetworks: false,
    isUpdatingFilterSettingReports: false,
    indexOfSelectedFilterSetting: null,
  }),
  computed: {
    ...mapToolsGetters([
      'customReportOptions',
      'organizations',
      'persons',
      'teams',
    ]),
    ...mapGetters([
      'errorMessage',
      'internals',
      'successMessage',
    ]),
    ...mapState({
      action: (state) => state.action,
      accountTypes: (state) => state.accountTypes,
      didLoadPersonFail: (state) => state.didLoadPersonFail,
      entry: (state) => state.entry,
      isLoadingPerson: (state) => state.isLoadingPerson,
      isPersonModalVisible: (state) => state.isPersonModalVisible,
      levels: (state) => state.levels,
      roles: (state) => state.roles,
      selected: (state) => state.selected,
    }),
    visible: {
      get() {
        return this.isPersonModalVisible
      },
      set(value) {
        this.$store.commit('internal/isPersonModalVisible', value)
      },
    },
    viewPerson() {
      const {
        persons,
        didLoadPersonFail,
        isLoadingPerson,
      } = this

      return isLoadingPerson === false
        && didLoadPersonFail === false
        && persons.length > 0
    },
    noPersonData() {
      const {
        persons,
        isLoadingPerson,
        didLoadPersonFail,
      } = this
      const requestComplete = isLoadingPerson === false
      const requestSucceeded = didLoadPersonFail === false
      const noResults = persons.length === 0

      return requestComplete && requestSucceeded && noResults
    },

    entryAccessRole: {
      get() {
        const { entry } = this
        const { access: { role } } = entry || {}

        return role
      },
      set(value) {
        // Set the Firestore document's access role to the selected value.
        this.entry.access.role = value

        // Set the corresponding database record's isInternal property to the selected value.
        this.entry.isInternal = value === 'internal'
      },
    },

    entryAliasEmail: {
      get() {
        const { entry } = this
        const { settings: { alias: { email } } } = entry || {}

        return email
      },
      set(selection) {
        this.entry.settings.alias.email = selection.value
      },
    },

    entrySetting: {
      get() {
        const { entry } = this
        const { settings = {} } = entry || {}

        return settings
      },
      set(newArray) {
        this.entry.settings = newArray
      },
    },

    currentNetworks: {
      get() {
        const { entry, organizations } = this
        const { network: networks = [] } = entry || {}

        return networks.map((network) => {
          const { organization: networkOrg } = network
          const { code: billingCode } = networkOrg
          const organization = organizations.find(this.findByBillingCode(billingCode))

          return { ...networkOrg, ...organization }
        })
      },
      set(newArray) {
        const { entry } = this
        const { network: networks = [] } = entry || {}

        if (!newArray?.length) {
          this.entry.network = []

          return this.entry.network
        }

        const isObject = (obj) => typeof obj === 'object' && obj !== null

        this.entry.network = newArray.reduce((userNetworks, network) => {
          const { billingCode } = network
          const previouslySelected = networks.find((nw) => nw.organization.code === billingCode)
          const usePreviouslySelectedTeam = isObject(previouslySelected) && Array.isArray(previouslySelected.team)
          const networkTeams = usePreviouslySelectedTeam ? previouslySelected.team : network.teams
          const networkAndTeams = this.makeNetworkConfig(network, networkTeams)

          userNetworks.push(networkAndTeams)

          return userNetworks
        }, [])

        return this.entry.network
      },
    },
    optionsTeams() {
      const { entry, organizations } = this
      const { network: networks = [] } = entry || {}
      const selectedBillingCodes = networks.map((network) => network.organization.code)

      return organizations
        .filter((org) => selectedBillingCodes.includes(org.billingCode))
        .reduce((teamsArray, org) => teamsArray.concat(org.teams), [])
    },
    currentTeams: {
      get() {
        const { entry, organizations = [] } = this
        const { network: networks = [] } = entry || {}

        return networks.reduce((teamsArray, network) => {
          const { organization: networkOrg, team: networkTeams = [] } = network
          const { code: billingCode } = networkOrg || {}
          const organization = organizations.find(this.findByBillingCode(billingCode))
          const { teams: allTeams = [] } = organization || {}

          const selectedTeams = networkTeams.map((team) => {
            const { code: teamCode, id: teamId } = team
            return allTeams.find((t) => String(t.teamId) === String(teamId) && String(t.teamCode) === String(teamCode))
          })

          return teamsArray.concat(selectedTeams)
        }, [])
      },
      set(newTeamsArray) {
        const { currentNetworks } = this

        // Create a lookup object for teams by billing code.
        const teamsByBillingCode = newTeamsArray.reduce((groups, team) => {
          const { billingCode } = team

          if (!groups[billingCode]) {
            groups[billingCode] = []
          }

          groups[billingCode].push(team)

          return groups
        }, {})

        // Create a new array of networks based on the current networks selected and the teamsByBillingCode.
        this.entry.network = currentNetworks.reduce((userNetworks, org) => {
          const { billingCode } = org
          const teams = teamsByBillingCode[billingCode]
          const networkAndTeams = this.makeNetworkConfig(org, teams)

          userNetworks.push(networkAndTeams)

          return userNetworks
        }, [])

        return this.entry.network
      },
    },
    entryFirstName: {
      get() {
        return this.entry?.personNameFirst
      },
      set(value) {
        this.entry.personNameFirst = value.trim()
      },
    },
    entryLastName: {
      get() {
        return this.entry?.personNameLast
      },
      set(value) {
        this.entry.personNameLast = value.trim()
      },
    },
    entryEmail: {
      get() {
        return this.entry?.email
      },
      async set(value) {
        // Set the Firestore document's email to the selected value.
        this.entry.email = value.trim().toLowerCase()
      },
    },
    rulesEmail() {
      const required = (value) => !!value || 'Required'
      const isEmail = (value) => /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value) || 'Invalid email address'

      return [required, isEmail]
    },
    rulesRequired() {
      return [(value) => !!value || 'Required']
    },
    entryDateText() {
      const { entry: { access: { expires } } } = this
      return dates.getFormattedDate(expires, 'dddd, MMMM DD, YYYY')
    },

    entrySettings() {
      return this.entry?.settings || {}
    },
    filterSettings: {
      get() {
        if (!this.entrySettings) return []

        return this.entrySettings.filters
      },
      set(newArray) {
        this.entry.settings.filters = newArray
      },
    },
    haveFilterSettings() {
      return this.filterSettings && this.filterSettings.length > 0
    },

    defaultFilterSetting() {
      return {
        name: undefined,
        network: [],
        parameters: [],
        reports: ['discrepancy', 'pacing'],
      }
    },

    allPropertyOptions() {
      const columns = this.$store.state.delivery?.columns
      const options = columns.map((column) => ({ text: column.columnName, value: column.key }))
      return _.sortDscByCaseInsensitive(options, 'text')
    },
    allOperatorOptions() {
      return _.sortDscByCaseInsensitive([...operators.numerical, ...operators.textual, ...operators.boolean], 'value')
    },
  },
  watch: {
    selected(newValue) {
      if (newValue) {
        // do something
      }
    },
    entry: {
      deep: true,
      handler() {
        this.updateTenantDataOnEntry()
      },
    },
    isPersonModalVisible: {
      async handler(newValue) {
        if (newValue) {
          const aliasEmailOptions = await this.$store.dispatch('auth/getAliasOptions', null)

          this.aliasEmailOptions = aliasEmailOptions.map((external) => ({
            text: external.docId,
            value: external.docId,
          }))
        }
      },
    },
  },
  created() {
    this.updateTenantDataOnEntry()
  },
  methods: {
    validate() {
      return this.$refs.personForm.validate()
    },
    reset() {
      return this.$refs.personForm.reset()
    },
    resetValidation() {
      return this.$refs.personForm.resetValidation()
    },
    close(action) {
      if (['cancel', 'delete'].indexOf(action) === -1) this.resetValidation()
      this.$store.commit('internal/isPersonModalVisible', false)
    },

    resetFilterSettingForm() {
      // Reset form data.
      this.entrySetting = { ...this.defaultFilterSetting }
      this.isEntrySettingPrefilter = false

      this.indexOfSelectedFilterSetting = null
      this.selectedFilterSetting = {}

      // Reset form state.
      this.isValidSettingForm = true
    },
    closeFilterSettingForm() {
      // Hide the filter setting form.
      this.showFilterSettingForm = false

      // Reset the form data.
      this.resetFilterSettingForm()
    },

    saveSettingForm() {
      const { entry: { settings }, entrySetting } = this
      const { filters } = settings || {}

      if (Array.isArray(filters)) {
        this.entry.settings.filters.push(entrySetting)
      } else {
        if (!this.entry.settings) {
          this.entry.settings = {}
        }

        this.entry.settings.filters = [entrySetting]
      }

      this.showFilterSettingForm = false
    },

    openFilterSettingForm(filterSettings) {
      // Store the index of the selected filter setting.
      this.indexOfSelectedFilterSetting = filterSettings.length - 1

      // Set the form data using the selected filter setting.
      this.filterSettings = filterSettings

      // Open the filter setting form.
      this.showFilterSettingForm = true
    },

    openSettingFormCreate() {
      // Create a new filter setting object.
      const filterSetting = { ...this.defaultFilterSetting }

      // Store the filter setting in case we need to restore it.
      this.selectedFilterSetting = { ...filterSetting }

      // Make the entry's settings.filters with the new filter setting.
      const filterSettings = [...this.filterSettings, filterSetting]

      // Get the index of the new filter setting.
      const indexOfSelectedFilterSetting = filterSettings.length - 1

      // Open the filter setting form with the new filter setting.
      this.openFilterSettingForm(indexOfSelectedFilterSetting, filterSettings)
    },

    closeFormToUpdateFilterName() {
      // Close the form that updates the filter name.
      this.isUpdatingFilterSettingName = false

      // Reset the form data.
      this.selectedFilterSetting = {}
      this.indexOfSelectedFilterSetting = null
    },

    cancelFormToUpdateFilterName() {
      // Get the selected filter setting and its index.
      const { selectedFilterSetting, indexOfSelectedFilterSetting } = this

      // Restore the name of the selected filter setting.
      this.entry.settings.filters[indexOfSelectedFilterSetting].name = selectedFilterSetting.name

      // Reset the form data.
      this.closeFormToUpdateFilterName()
    },

    openFormToUpdateFilterName(settingIndex) {
      // Get the selected filter setting using the provided index.
      const filterSetting = this.filterSettings[settingIndex]

      // Store the selected filter setting in case we need to restore it.
      this.selectedFilterSetting = { ...filterSetting }

      // Store the index of the selected filter setting.
      this.indexOfSelectedFilterSetting = settingIndex

      // Open the filter setting form with the selected filter setting.
      this.isUpdatingFilterSettingName = true
    },

    updateFilterName() {
      const { filterSettings, indexOfSelectedFilterSetting } = this
      const filterSetting = filterSettings[indexOfSelectedFilterSetting]

      // Update the name of the selected filter setting.
      this.entry.settings.filter[indexOfSelectedFilterSetting].name = filterSetting.name

      // Reset the form and close it.
      this.closeFormToUpdateFilterName()
    },

    cancelFormToDeleteFilterSetting() {
      // Close the form that confirms the deletion of the filter setting.
      this.isDeletingFilterSetting = false

      // Reset the index of the selected filter setting.
      this.indexOfSelectedFilterSetting = null
    },

    deleteFilterSetting() {
      const { indexOfSelectedFilterSetting } = this

      // Remove the selected filter setting from the entry's settings.
      this.entry.settings.filters.splice(indexOfSelectedFilterSetting, 1)

      // Close the form that confirms the deletion of the filter setting.
      this.cancelFormToDeleteFilterSetting()
    },

    promptToDeleteFilterSetting(filterSettingIndex) {
      // Set the index of the selected filter setting.
      this.indexOfSelectedFilterSetting = filterSettingIndex

      // Show form that confirms the deletion of the filter setting.
      this.isDeletingFilterSetting = true
    },

    cancelFormToUpdateFilterParameters() {
      // Close the form that updates the filter parameters.
      this.isUpdatingFilterSettingParameters = false

      // Reset the form data.
      this.entry.settings.filters[this.indexOfSelectedFilterSetting].parameters = this.selectedFilterSetting.parameters

      this.selectedFilterSetting = {}
      this.indexOfSelectedFilterSetting = null
    },

    openFormToUpdateFilterParameters(filterSettingIndex) {
      // Get the selected filter setting using the provided index.
      const filterSetting = this.filterSettings[filterSettingIndex]

      // Store the selected filter setting in case we need to restore it.
      this.selectedFilterSetting = { ...filterSetting }

      // Store the index of the selected filter setting.
      this.indexOfSelectedFilterSetting = filterSettingIndex

      // Show the form that allows editing of filter parameters.
      this.showFilterSettingForm = true
    },

    cancelFormToUpdateFilterNetworks() {
      // Close the form that updates the filter networks.
      this.isUpdatingFilterSettingNetworks = false

      // Restore the networks of the selected filter setting.
      const { selectedFilterSetting, indexOfSelectedFilterSetting } = this

      this.entry.settings.filters[indexOfSelectedFilterSetting].network = selectedFilterSetting.network

      // Reset the form data.
      this.selectedFilterSetting = {}
      this.indexOfSelectedFilterSetting = null
    },

    openFormToUpdateFilterNetworks(filterSettingIndex) {
      // Get the selected filter setting using the provided index.
      const filterSetting = this.filterSettings[filterSettingIndex]

      // Store the selected filter setting in case we need to restore it.
      this.selectedFilterSetting = { ...filterSetting }

      // Store the index of the selected filter setting.
      this.indexOfSelectedFilterSetting = filterSettingIndex

      // Show the form that allows editing of filter networks.
      this.isUpdatingFilterSettingNetworks = true
    },

    updateFilterNetworks() {
      const { filterSettings, indexOfSelectedFilterSetting } = this
      const filterSetting = filterSettings[indexOfSelectedFilterSetting]

      // Update the networks of the selected filter setting.
      this.entry.settings.filters[indexOfSelectedFilterSetting].network = filterSetting.network

      // Reset the form and close it.
      this.cancelFormToUpdateFilterNetworks()
    },

    cancelFormToUpdateFilterReports() {
      // Close the form that updates the filter reports.
      this.isUpdatingFilterSettingReports = false

      // Restore the reports of the selected filter setting.
      const { selectedFilterSetting, indexOfSelectedFilterSetting } = this

      this.entry.settings.filters[indexOfSelectedFilterSetting].reports = selectedFilterSetting.reports

      // Reset the form data.
      this.selectedFilterSetting = {}
      this.indexOfSelectedFilterSetting = null
    },

    openFormToUpdateFilterReports(filterSettingIndex) {
      // Get the selected filter setting using the provided index.
      const filterSetting = this.filterSettings[filterSettingIndex]

      // Store the selected filter setting in case we need to restore it.
      this.selectedFilterSetting = { ...filterSetting }

      // Store the index of the selected filter setting.
      this.indexOfSelectedFilterSetting = filterSettingIndex

      // Show the form that allows editing of filter reports.
      this.isUpdatingFilterSettingReports = true
    },

    updateFilterReports() {
      const { filterSettings, indexOfSelectedFilterSetting } = this
      const filterSetting = filterSettings[indexOfSelectedFilterSetting]

      // Update the reports of the selected filter setting.
      this.entry.settings.filters[indexOfSelectedFilterSetting].reports = filterSetting.reports

      // Reset the form and close it.
      this.cancelFormToUpdateFilterReports()
    },

    openSettingFormUpdate(settingIndex) {
      const setting = this.entry.settings.filters[settingIndex]
      this.openSettingForm(setting)
    },

    deleteSettingParameters(columnKey, valueIndex) {
      this.entrySetting.parameters[columnKey].splice(valueIndex, 1)
    },
    saveSettingParameters() {
      const { key, operator, value } = this.entrySettingParameter

      if (!Array.isArray(this.entrySetting.parameters[key])) {
        this.entrySetting.parameters[key] = [{ operator, value }]
      } else {
        this.entrySetting.parameters[key].push({ operator, value })
      }

      this.entrySettingParameter = { key, operator, value: undefined }
    },

    getOrgAndTeamName(network) {
      const orgTeam = this.teams.find((team) => team.billingCode === network.billingCode && team.teamId === network.teamId && team.teamCode === network.teamCode)
      return orgTeam?.teamName || 'Unknown Team Name'
    },

    async submit(entry) {
      const { action, isValidPersonForm } = this
      const requiresValidation = ['create', 'update'].includes(action)
      const validates = () => requiresValidation && isValidPersonForm
      const valid = !requiresValidation || validates()
      const { commit, dispatch } = this.$store

      if (!valid) {
        const message = 'Invalid Form'

        commit('tools/snackbar', true)
        commit('tools/snack', { message, status: 'error' })

        return false
      }

      entry.action_type = action.toUpperCase()

      const response = await dispatch('internal/submitPersonAction', entry)
      const { code, error } = response || {}

      if (error || code || !response) {
        const message = error?.message || response?.message || response?.code || 'Unknown API Error'

        commit('tools/snackbar', true)
        commit('tools/snack', { message, status: 'error' })

        return error || { error: true, message }
      }

      const { access, network } = response
      const isSuccessResponse = typeof access === 'object' && typeof network === 'object'
      const status = isSuccessResponse ? 'success' : 'error'
      const message = isSuccessResponse ? this.successMessage : this.errorMessage

      if (isSuccessResponse) {
        this.close(action)
      }

      commit('tools/snackbar', true)
      commit('tools/snack', { message, status })

      return { request: entry, response }
    },

    async copy(entry) {
      return this.$store.dispatch('internal/showFormPersonCopy', entry, { root: true })
    },

    async submitAction(actionName) {
      const { entry } = this
      const isCopyAction = actionName === 'submit-and-copy'

      const { error } = await this.submit(entry)

      if (!error && isCopyAction) {
        const { error: copyError } = await this.copy(entry)

        if (copyError) {
          const message = copyError?.message || 'Copy Error Unknown'

          this.$store.commit('tools/snackbar', true)
          this.$store.commit('tools/snack', { message, status: 'error' })

          return { error: true, message }
        }

        return { error: false }
      }

      return { error }
    },

    cancelAction() {
      const { selected } = this

      this.$store.commit('internal/action', 'read')
      this.$store.commit('internal/entry', Object.create(selected))

      this.close('cancel')
    },

    findByBillingCode(billingCode) {
      return (nw) => nw.billingCode === billingCode
    },

    makeNetworkConfig(selectedOrg, selectedTeams = []) {
      const { billingCode, networkCode, publisherId } = selectedOrg

      return {
        organization: {
          ...selectedOrg,
          id: publisherId,
          code: billingCode,
          networkCode,
        },
        team: selectedTeams.map((team) => {
          team.billingCode = billingCode
          return team
        }),
      }
    },

    async updateTenantDataOnEntry() {
      if (!this.entry || !this.entry.email) {
        return {}
      }

      if (!this.entry.domainName) {
        const domain = this.entry.email.split('@')[1]

        // Set the Firestore document's domainName to the email domain.
        this.entry.domainName = domain ? domain.toLowerCase() : ''
      }

      if (!this.entry.enterpriseId) {
        // Find the enterprise document that has the domain in its domains array.
        const enterprise = await this.$store.dispatch('auth/getEnterpriseByDomain', this.entry.domainName)

        if (enterprise) {
          // Populate the enterpriseId on the entry.
          this.entry.enterpriseId = enterprise.docId
        }

        // Find the domain document that matches the domain name.
        const domain = this.entry.domainName
        const domainDoc = await this.$store.dispatch('auth/getDomainDocFromFirestore', domain)

        if (domainDoc) {
          const { docId, shortName, tenantHash } = domainDoc

          if (!this.entry.domainName || this.entry.domainName !== docId) {
            // Use the domainName configured on the document to overwrite the domainName found in the email.
            // This happens when an enterprise has users with multiple email domains.
            // The domainName on the domain document is the primary domain for the enterprise.
            this.entry.domainName = docId
          }

          this.entry.tenantId = `${shortName}${tenantHash ? `-${tenantHash}` : ''}`
        }
      }

      return this.entry
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~src/styles/variables";

.v-btn:not(.v-btn--round).v-size--default {
  min-width: 36px;
}

::v-deep.v-card {
  border-radius: 6px;
  border-width: 0;
}

::v-deep.v-card__title {
  color: $color-monochrome-darkestblue;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0.51px;
  line-height: 22px;
  justify-content: space-between;
}

::v-deep.v-card__text {
  padding: 0;
}

.v-card + .v-card {
  margin-top: 1ch;
}

.checkbox-field {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

.checkbox-field__content {
  line-height: 1.2;
}

.checkbox-field__label {
  font-size: 0.9rem;
  font-weight: 500;
}

.checkbox-field__hint {
  color: rgba(0, 0, 0, 0.6);
  font-size: 0.75rem;
}
</style>
